import { useTranslation } from 'react-i18next';
import { brandAssets } from '@/mocks/brand';

interface BrandLogoProps {
  className?: string;
}

export default function BrandLogo({ className = '' }: BrandLogoProps) {
  const { t } = useTranslation();

  return (
    <img
      src={brandAssets.logo}
      alt={t('comingSoonLogoAlt')}
      title="CHARVYS - AI Business Solutions"
      width={1200}
      height={400}
      fetchPriority="high"
      className={`h-auto object-contain ${className}`}
    />
  );
}